module.exports = __webpack_public_path__ + "img/16_107.b6fa580c.png";